import styled from "styled-components";
export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${({ theme }) => theme.green};
  padding: 0.8rem 7.625rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100003;
`;

export const SocialsContainer = styled.div`
  display: flex;
  gap: 14px;
`;

export const SocialElement = styled.a`
  display: flex;
  gap: 12px;
  align-items: center;

  svg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }

  > * {
    color: ${({ theme }) => theme.white} !important;
    font-weight: 100 !important;
  }

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.white};
    padding-right: 14.5px;
  }
`;

export const UtilsContainer = styled.div`
  display: flex;
  gap: 29px;
`;

export const UtilElement = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  > * {
    color: ${({ theme }) => theme.white} !important;
    font-weight: 100 !important;
    cursor: pointer !important;

    > * {
      color: ${({ theme }) => theme.white} !important;
      font-weight: 100 !important;
      cursor: pointer;
    }
  }
`;
